/**
 * workflowTemplates.ts
 *
 * Pre-built starter workflows for the WorkflowBuilder template picker.
 *
 * Each template stores skill IDs (not full WorkflowStep objects): the builder
 * resolves them against the live marketplace at "Use template" time so each
 * step gets the skill's real version and inputSchema. Templates are built from
 * the actual verified marketplace skills:
 *   email-sender, json-transformer, linkedin-parser, openai-chat,
 *   openai-summarizer, pdf-parser, salesforce-writer, slack-notifier, sql-executor
 */

import { Cloud, FileText, Linkedin, Mail, type LucideIcon } from 'lucide-react'

export interface WorkflowTemplate {
  id: string
  name: string
  description: string
  icon: LucideIcon
  /** Marketplace skill IDs, in execution order. Resolved live by the builder. */
  skillIds: string[]
}

export const TEMPLATES: readonly WorkflowTemplate[] = [
  {
    id: 'document-digest',
    name: 'Document Digest',
    description: 'Extract text from a PDF, summarise it, and post the summary to Slack.',
    icon: FileText,
    skillIds: ['pdf-parser', 'openai-summarizer', 'slack-notifier'],
  },
  {
    id: 'linkedin-enrich',
    name: 'LinkedIn Enrich',
    description: 'Extract structured data from a LinkedIn profile and store it.',
    icon: Linkedin,
    skillIds: ['linkedin-parser', 'sql-executor'],
  },
  {
    id: 'draft-send-email',
    name: 'Draft & Send Email',
    description: 'Generate an email with AI and send it via the email service.',
    icon: Mail,
    skillIds: ['openai-chat', 'email-sender'],
  },
  {
    id: 'sync-salesforce',
    name: 'Sync to Salesforce',
    description: 'Remap JSON fields and upsert the record into Salesforce.',
    icon: Cloud,
    skillIds: ['json-transformer', 'salesforce-writer'],
  },
]
